<template>
  <div class="select-field-wrap">
    <el-popover
      placement="bottom"
      width="150"
      trigger="hover"
      :disabled="customData.length === 0"
    >
      <div class="select-field-hover-wrap">
        <div class="hover-title">常用自定义列</div>
        <ul class="custom-list">
          <li
            :class="[
              'custom-item',
              item.template_id === curCustom.template_id ? 'cur' : '',
            ]"
            v-for="item of customData"
            :key="item.template_id"
            @click="setCurCustom(item)"
          >
            <div class="down-item-wrap">
              <i class="el-icon-check check-icon"></i>
              <span class="item-name" :title="item.name">{{ item.name }}</span>
              <i
                class="el-icon-edit edit-icon"
                @click="(e) => editCustomCols(e, item)"
              ></i>
              <i
                v-if="item.template_id !== curCustom.template_id"
                class="el-icon-close close-icon"
                @click="(e) => delCustomCols(e, item)"
              ></i>
            </div>
          </li>
        </ul>
        <div class="choose-custom" @click="checkField(true)">选择自定义列</div>
      </div>
      <el-button
        slot="reference"
        @click="checkField()"
        class="top-btn"
        icon="el-icon-arrow-down"
      >
        {{ btnText }}
      </el-button>
    </el-popover>
    <el-dialog
      :title="btnText"
      :visible.sync="dialogVisible"
      :width="`${modalWidth}px`"
      :close-on-click-modal="false"
    >
      <div class="modal-body">
        <div class="content-wrap">
          <div class="left-wrap">
            <el-input
              placeholder="请输入列名称"
              suffix-icon="el-icon-search"
              v-model="searchStr"
              class="search-input"
              :style="{ marginBottom: showAttributionData ? '10px' : 0 }"
            >
            </el-input>
            <el-tabs
              v-if="showAttributionData"
              v-model="tabsActiveName"
              type="card"
              @tab-click="() => (searchStr = '')"
            >
              <el-tab-pane label="媒体数据" name="mediaData"></el-tab-pane>
              <el-tab-pane
                label="归因数据"
                name="attributionData"
              ></el-tab-pane>
            </el-tabs>
            <ul class="field-list">
              <li
                class="field-item"
                v-for="groupItem of filterOptions"
                :key="groupItem.title"
              >
                <div class="item-header">
                  <el-checkbox
                    v-model="groupItem.selectAll"
                    @change="(value) => selectAllItem(value, groupItem.list)"
                    >{{ groupItem.title }}</el-checkbox
                  >
                </div>
                <div class="item-list">
                  <el-checkbox
                    v-for="checkItem of groupItem.list"
                    :key="checkItem.value"
                    v-model="totalData[checkItem.value].value"
                    @change="
                      (value) => changeSelect(checkItem.value, value, groupItem)
                    "
                  >
                    <el-tooltip placement="top" v-if="checkItem.tips">
                      <div slot="content">
                        {{ checkItem.tips }}
                      </div>
                      <div>
                        {{ checkItem.label
                        }}<i class="el-icon-question" style="margin: 2px"></i>
                      </div>
                    </el-tooltip>
                    <div v-else>{{ checkItem.label }}</div>
                  </el-checkbox>
                </div>
              </li>
            </ul>
          </div>
          <div class="right-wrap">
            <div class="total-header">
              <span class="total-text"
                >已选择
                {{
                  staticOptions.length +
                  selectValue.fixed.length +
                  selectValue.custom.length
                }}
                列</span
              >
              <el-button type="text" @click="clearAll">清除</el-button>
            </div>
            <div
              class="select-list"
              :style="{
                'min-height': isHasFixed ? '20px' : '0',
                'flex-shrink': 0,
              }"
            >
              <div
                class="select-item"
                v-for="item of staticOptions"
                :key="item.value"
              >
                {{ item.label }}
              </div>
              <vue-draggable
                :force-fallback="true"
                ghostClass="ghost"
                group="fieldGroup"
                animation="300"
                v-model="selectValue.fixed"
              >
                <div
                  class="select-item"
                  v-for="item of selectValue.fixed"
                  :key="item"
                >
                  {{ totalData[item]?.label }}
                  <i
                    class="el-icon-close close-icon"
                    @click="delItem(item)"
                  ></i>
                </div>
              </vue-draggable>
            </div>
            <div class="center-line" v-if="isHasFixed">
              --拖到上方的列将固定显示--
            </div>
            <div class="select-list bottom-list">
              <vue-draggable
                :force-fallback="true"
                ghostClass="ghost"
                group="fieldGroup"
                animation="300"
                v-model="selectValue.custom"
              >
                <div
                  class="select-item"
                  v-for="item of selectValue.custom"
                  :key="item"
                >
                  {{ totalData[item]?.label }}
                  <i
                    class="el-icon-close close-icon"
                    @click="delItem(item)"
                  ></i>
                </div>
              </vue-draggable>
            </div>
          </div>
        </div>
        <span slot="footer" class="footer-wrap">
          <div class="save-wrap">
            <el-form
              :inline="true"
              :model="formData"
              :rules="rules"
              ref="nameForm"
            >
              <el-form-item style="margin: 0px">
                <el-checkbox-group v-model="isSave">
                  <el-checkbox
                    :disabled="editId ? true : false"
                    label="保存为常用自定义列"
                  ></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item
                prop="colName"
                style="margin: 0px 0px 0px 16px"
                v-show="isSave"
              >
                <el-input
                  type="text"
                  placeholder="请输入名称"
                  v-model="formData.colName"
                  maxlength="30"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="bottom-wrap">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmSelect">确 定</el-button>
          </div>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VueDraggable from "vuedraggable";
import {
  saveDefineColumn,
  searchDefineColumn,
  modifyDefineColumn,
  deleteDefineColumn,
} from "@/api/tableSort.js";
export default {
  name: "selectField",
  props: {
    //默认指标
    defaultIndexName: {
      type: Object,
      default: () => ({
        custom: [],
        fixed: [],
      }),
    },
    //展示项
    options: {
      type: Array,
      default: () => [],
    },
    //固定项
    staticOptions: {
      type: Array,
      default: () => [],
    },
    //当前表格类型 1投放账号 2广告组
    type: {
      type: Number,
      require: true,
      default: 20,
    },
    // 兼容部分报表不显示归因数据指标
    showAttributionData: {
      type: Boolean,
      default: true,
    },
    // 是否有固定列
    isHasFixed: {
      type: Boolean,
      default: true,
    },
    modalWidth: {
      type: Number,
      default: 900,
    },
    btnText: {
      type: String,
      default: "选择指标",
    },
  },
  components: {
    VueDraggable,
  },
  data() {
    return {
      dialogVisible: false,
      isSave: false,
      editFrom: "isTemplateIndex",
      formData: {
        colName: "",
      },
      rules: {
        colName: [
          {
            validator: (rule, value, callback) => {
              if (this.isSave && value === "") {
                callback(new Error("请输入自定义列名"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      searchStr: "",
      checkList: [],
      selectValue: {
        fixed: [], //固定列
        custom: [], //自定义列
      },
      totalData: {},
      testValue: false,
      customData: [],
      curCustom: {
        content: {
          custom: [],
          fixed: [],
        },
        name: "",
        template_id: null,
      }, //当前的自定义列数据
      editId: null, //当前的编辑数据
      tabsActiveName: "mediaData", // mediaData 媒体数据 attributionData 归因数据
    };
  },
  mounted() {
    setTimeout(() => {
      this.searchColData();
    }, 100);
  },
  methods: {
    searchColData() {
      searchDefineColumn({ type: this.type }).then((res) => {
        if (res.code === "0000") {
          this.customData = res.data.map((item) => {
            return {
              template_id: item.id,
              name: item.templateName,
              content: JSON.parse(item.templateData),
            };
          });
          this.selectValue = {
            fixed: [], //固定列
            custom: [], //自定义列
          };
          if (this.customData.length > 0) {
            this.$emit("changeColumn", this.customData[0]?.content);
          } else {
            const { custom = [], fixed = [] } = this.defaultIndexName;
            this.$emit("changeColumn", { fixed, custom });
          }
        }
      });
    },
    checkField(flag) {
      if (this.customData.length === 0 || flag) {
        this.editId = null;
        this.isSave = false;
        this.formData.colName = "";

        this.selectValue.custom = this.defaultIndexName.custom.filter(
          (item) => this.totalData[item]
        );
        this.selectValue.fixed = this.defaultIndexName.fixed.filter(
          (item) => this.totalData[item]
        );
        this.dialogVisible = true;
        this.editFrom = "isCustomIndex";
      }
    },
    delItem(key) {
      let delIndex = this.selectValue.custom.findIndex((item) => item === key);
      if (delIndex !== -1) {
        this.selectValue.custom.splice(delIndex, 1);
      } else {
        let fixedIndex = this.selectValue.fixed.findIndex(
          (item) => item === key
        );
        if (fixedIndex !== -1) {
          this.selectValue.fixed.splice(fixedIndex, 1);
        }
      }
    },
    clearAll() {
      this.selectValue.fixed = [];
      this.selectValue.custom = [];
    },
    changeSelect(label, value, groupItem) {
      if (value) {
        this.selectValue.custom.push(label);
      } else {
        this.delItem(label);
      }

      if (!groupItem.list) return;

      // totalData[label].value
      groupItem.selectAll = groupItem.list.every(
        (item) => this.totalData[item.value].value
      );
    },
    setCurCustom(data) {
      if (this.customData.length === 0) return;
      if (data) {
        // 新增取消勾选模板逻辑
        if (data.template_id === this.curCustom.template_id) {
          const initData = this.$options.data();
          this.curCustom = initData.curCustom;
          // 当不选模板字段时,使用默认字段
          initData.selectValue.custom = this.defaultIndexName.custom;
          initData.selectValue.fixed = this.defaultIndexName.fixed;
          this.selectValue = initData.selectValue;
          this.$emit("changeColumn", initData.selectValue);
        } else {
          //选择了自定义数据
          this.curCustom = data;
          this.$emit("changeColumn", data.content);
        }
      } else {
        //初始化
        this.curCustom = this.customData[0];
      }
      this.selectValue.fixed = this.curCustom.content.fixed.filter(
        (item) => this.totalData[item]
      );
      this.selectValue.custom = this.curCustom.content.custom.filter(
        (item) => !!this.totalData[item]
      );
    },
    editCustomCols(e, dataItem) {
      e.stopPropagation();
      this.editId = dataItem.template_id;
      this.formData.colName = dataItem.name;
      this.selectValue.fixed = dataItem.content.fixed.filter(
        (item) => this.totalData[item]
      );
      this.selectValue.custom = dataItem.content.custom.filter(
        (item) => this.totalData[item]
      );
      this.isSave = true;
      this.dialogVisible = true;
      this.editFrom = "isTemplateIndex";
    },
    delCustomCols(e, dataItem) {
      e.stopPropagation();
      this.$confirm(
        '确认删除常用自定义列 "' + dataItem.name + '" ？此操作不可逆',
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          deleteDefineColumn({
            id: dataItem.template_id,
          }).then((res) => {
            if (res.code === "0000") {
              this.$message({
                message: "自定义列删除成功！",
                type: "success",
              });
              this.searchColData();
            }
          });
        })
        .catch(() => {});
    },
    //确认选择
    confirmSelect() {
      this.$refs.nameForm.validate((valid) => {
        if (valid) {
          if (this.isSave) {
            let data = {
              templateName: this.formData.colName,
              templateData: JSON.stringify(this.selectValue),
              type: this.type,
            };
            if (this.editId) {
              data.id = this.editId;
              modifyDefineColumn(data).then((res) => {
                if (res.code === "0000") {
                  this.dialogVisible = false;
                  this.$message({
                    message: "自定义列修改成功！",
                    type: "success",
                  });
                  this.searchColData();
                }
              });
            } else {
              saveDefineColumn(data).then((res) => {
                if (res.code === "0000") {
                  this.dialogVisible = false;
                  this.$message({
                    message: "自定义列保存成功！",
                    type: "success",
                  });
                  this.searchColData();
                }
              });
            }
          } else {
            this.curCustom = {};
            this.$emit(
              "changeColumn",
              {
                fixed: this.selectValue.fixed,
                custom: this.selectValue.custom,
              },
              this.editFrom
            );
            this.dialogVisible = false;
          }
        }
      });
    },
    selectAllItem(isSelectAll, list) {
      list.forEach((item) => {
        if (isSelectAll) {
          if (
            !this.selectValue.fixed
              .concat(this.selectValue.custom)
              .includes(item.value)
          ) {
            this.selectValue.custom.push(item.value);
          }
        } else {
          this.totalData[item.value].value = false;
          this.delItem(item.value);
        }
      });
    },
  },
  watch: {
    changeFieldValue: {
      handler(val) {
        let valueMap = {};
        val.allOptions.forEach((groupItem) => {
          groupItem.list.forEach((item) => {
            let isChecked = val.checkList.includes(item.value);
            valueMap[item.value] = {
              value: isChecked,
              label: item.label,
            };
          });
        });
        this.totalData = valueMap;
      },
      immediate: true,
      deep: true,
    },
    customData() {
      this.setCurCustom();
    },
  },
  computed: {
    changeFieldValue() {
      let checkList = this.selectValue.fixed.concat(this.selectValue.custom);
      return {
        checkList,
        allOptions: this.allOptions,
      };
    },
    allOptions() {
      //所有下拉项
      return this.options.length > 0
        ? this.options?.map((item) => {
            this.$set(item, "selectAll", false); //添加全选标识
            return item;
          })
        : [];
    },
    filterOptions() {
      let searchVal = this.searchStr.trim();

      let options = this.allOptions
        .map((item) => {
          if (item.title === "基础数据") {
            return {
              ...item,
              list: item.list.filter((basicItem) => {
                const result = [
                  "roiDay365",
                  //  "ltvDay365",
                  "incomeDay365",
                ].includes(basicItem.value);
                return this.tabsActiveName === "mediaData" ? !result : result;
              }),
            };
          }

          return item;
        })
        .filter((item) => {
          const mediaDataIndexes = [
            "ROI数据",
            "LTV数据",
            "总收入数据",
            "留存数据",
            "内购收入数据",
          ];
          if (this.tabsActiveName !== "mediaData")
            mediaDataIndexes.push("基础数据");

          const result = mediaDataIndexes.includes(item.title);
          return this.tabsActiveName === "mediaData" ? !result : result;
        }); //所有列

      if (searchVal === "") return options;
      let copyData = JSON.parse(JSON.stringify(options));
      return copyData.reduce((res, groupItem) => {
        groupItem.list = groupItem.list.filter((item) =>
          item.label.includes(searchVal)
        );
        if (groupItem.list.length > 0) {
          res.push(groupItem);
        }
        return res;
      }, []);
    },
  },
};
</script>

<style lang="less" scoped>
.select-field-wrap {
  .top-btn {
    color: rgba(24, 144, 255, 1);
    font-size: 14px;
    border-radius: 2px;
    border: 1px solid rgba(24, 144, 255, 1);
    background: rgba(255, 255, 255, 1);
  }
  .modal-body {
    .content-wrap {
      display: flex;
      .left-wrap {
        width: 100%;
        margin-right: 12px;
        /deep/ .el-input__icon {
          line-height: 35px;
        }
        /deep/ .el-tabs__header {
          margin-bottom: -17px;
        }
        .field-list {
          padding: 0px;
          margin: 16px 0 0 0;
          list-style: none;
          height: 450px;
          overflow: auto;
          &::-webkit-scrollbar {
            display: none;
          }
          .field-item {
            border: 1px solid rgba(0, 0, 0, 0.15);
            box-sizing: border-box;
            background: rgba(255, 255, 255, 1);
            margin-bottom: 16px;
            .item-header {
              height: 38px;
              border-radius: 2px;
              background: rgba(244, 244, 244, 0.6);
              line-height: 38px;
              padding-left: 12px;
              /deep/ .el-checkbox__label {
                color: rgba(0, 0, 0, 0.85);
                font-weight: bold;
                font-size: 14px;
              }
            }
            .item-list {
              padding: 12px 12px 0px 12px;
              /deep/ .el-checkbox {
                width: 33.3%;
                margin: 0 0 12px 0;
              }
              // .checkbox-group {

              // }
            }
          }
        }
      }
      .right-wrap {
        border: 1px solid rgba(0, 0, 0, 0.15);
        box-sizing: border-box;
        height: 500px;
        width: 28%;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        .total-header {
          height: 38px;
          line-height: 38px;
          padding: 0 12px;
          display: flex;
          .total-text {
            color: rgba(0, 0, 0, 0.85);
            font-weight: bold;
            font-size: 14px;
            margin-right: auto;
          }
        }
        .center-line {
          color: rgba(0, 0, 0, 0.85);
          font-size: 12px;
          text-align: center;
          margin-bottom: 8px;
          flex-shrink: 0;
        }
        .select-list {
          padding: 0 8px;
          .select-item {
            height: 38px;
            line-height: 38px;
            border-radius: 2px;
            background: rgba(244, 244, 244, 0.6);
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
            padding-left: 12px;
            position: relative;
            margin-bottom: 8px;
            user-select: none;
            .close-icon {
              position: absolute;
              right: 10px;
              top: 13px;
              cursor: pointer;
            }
          }
          &.bottom-list {
            overflow: auto;
            &::-webkit-scrollbar {
              display: none;
            }
          }
          .ghost {
            border: 2px dotted #409eff;
            box-sizing: border-box;
          }
        }
      }
    }
    .footer-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 0px 24px 0px;
      .save-wrap {
        display: flex;
        align-items: center;
      }
    }
  }
}

.select-field-hover-wrap {
  .hover-title {
    font-size: 14px;
    color: #999;
    text-align: center;
    margin-bottom: 6px;
  }
  .custom-list {
    padding: 0px;
    margin: 0px;
    list-style: none;
    .custom-item {
      font-size: 14px;
      padding: 4px 0 4px 20px;
      cursor: pointer;
      position: relative;
      .down-item-wrap {
        display: flex;
        align-items: center;
        .check-icon {
          position: absolute;
          left: 2px;
          top: 6px;
          display: none;
        }
        .item-name {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .edit-icon {
          margin-left: auto;
          margin-right: 6px;
          color: #333;
          display: none;
        }
        .close-icon {
          color: #333;
          margin-right: 6px;
          display: none;
        }
      }
      &.cur {
        color: #1890ff;
        .check-icon {
          display: inline-block;
        }
      }
      &:hover {
        background: rgba(244, 244, 244, 0.6);
        .down-item-wrap {
          .edit-icon,
          .close-icon {
            display: inline-block;
          }
        }
      }
    }
  }
  .choose-custom {
    margin-top: 6px;
    border-top: 1px solid #eee;
    padding: 5px;
    text-align: center;
    cursor: pointer;
    &:hover {
      color: #1890ff;
    }
  }
}
</style>
